import React, { forwardRef, useState } from 'react';
import ArgonInput from 'component/Argon/ArgonInput';
import { Box, Typography } from '@mui/material';
import Iconify from 'component/iconify';

const PasswordField = forwardRef(({ size = 'large', placeholder = 'รหัสผ่าน', error, ...rest }, ref) => {
  const [showPwd, setShowPwd] = useState(false);
  return (
    <>
      <ArgonInput
        ref={ref}
        type={showPwd ? 'text' : 'password'}
        placeholder={placeholder}
        size={size}
        error={!!error}
        {...rest}
        endAdornment={
          <Box
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              setShowPwd((prev) => !prev);
            }}
          >
            {showPwd ? (
              <Iconify width={24} icon="eva:eye-outline" />
            ) : (
              <Iconify width={24} icon="eva:eye-off-outline" />
            )}
          </Box>
        }
      />
      {!!error?.message && (
        <Box ml={0.5}>
          <Typography component="label" color="red" variant="caption" fontWeight="bold">
            {`${error?.message}`}
          </Typography>
        </Box>
      )}
    </>
  );
});

export default PasswordField;
